import { Map } from "immutable";
import User from "contracts/responses/User";
import { SECURITY_GET_USER_SUCCESSFUL } from "UserAuthorized/actionTypes";

const InitialState = {
  userInfo: Map(new User())
};

const securityReducer = (state = Map(InitialState), action) => {
  switch (action.type) {
    case SECURITY_GET_USER_SUCCESSFUL:
      return state.set("userInfo", Map(action.payload));
    default:
      return state;
  }
};

export default securityReducer;
